<template>
  <div class="teaser-map">
    <TeaserMapButton
      :title="$texts('showLocationsOnMap')"
      @open="onClick"
    />
    <PageModal :modal-id>
      <div class="h-screen w-screen">
        <Component
          :is="mapComponent"
          :nids="nids"
          :external-blocks="externalBlocks"
        />
      </div>
    </PageModal>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphTeaserFragment } from '#graphql-operations'

const { $texts } = useEasyTexts()
const props = withDefaults(
  defineProps<{
    nids?: string[]
    externalBlocks?: ParagraphTeaserFragment[]
    mapId: string
  }>(),
  {
    nids: () => [],
    externalBlocks: () => [],
  },
)

const { openModal, modalId } = useModal(props.mapId)

const mapComponent = defineAsyncComponent(() => import('./Loader.vue'))

const { trackEvent } = useAnalytics()

function onClick() {
  trackEvent('click_show_location_on_map')
  openModal()
}
</script>

<style>
@reference '~/assets/css/tailwind.css';
.teaser-map {
  .modal-container {
    @apply h-screen w-screen;
    @variant desktop {
      width: calc(100vw - 10rem);
      height: calc(100vh - 6rem);
    }
  }
}
.teaser-grid + .teaser-map {
  @apply mt-size-4;
}
</style>
